import { render, staticRenderFns } from "./xxgkDetail.vue?vue&type=template&id=5891a118&scoped=true"
import script from "./xxgkDetail.vue?vue&type=script&lang=js"
export * from "./xxgkDetail.vue?vue&type=script&lang=js"
import style0 from "./xxgkDetail.vue?vue&type=style&index=0&id=5891a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891a118",
  null
  
)

export default component.exports